// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-input {\n  float: right !important;\n  margin-top: 0x;\n  margin-left: 10px;\n}\n.header-input .customSelect {\n  padding-bottom: 0 !important;\n}\n.header-input .customSelect .q-field__inner {\n  padding: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
